module.exports = {"roverBaseUrl":"https://sfo-rover.prod.samsclub.com"}


//////////////////
// WEBPACK FOOTER
// ./src/config/production.json
// module id = 529
// module chunks = 5